import { NgModule } from '@angular/core';
import { DisplayIdDirective } from './displayid.directive';

@NgModule({
  imports: [

  ],
  declarations: [
    DisplayIdDirective
  ],
  exports: [
    DisplayIdDirective
  ]
})

export class DisplayIdModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/displayid/displayid.module.ts